<template>
  <div class="inner-empty c:col-center">
    <img src="@/assets/icons/empty.svg" alt="" />
    <p>{{ text }}</p>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="less">
.inner-empty {
  width: 100%;
  height: 100%;
  padding: 46/20rem 0;

  img {
    width: 100/40rem;
    height: auto;
  }

  p {
    text-align: center;
    color: #909090;
    font-size: 14px;
    margin-top: 10px;
  }
}
</style>
